<div *ngIf='dataLoading' class="dataLoading">
  <mat-spinner class="m-auto" diameter="50"></mat-spinner>
</div>
<ng-container *ngIf='!dataLoading'>
  <div mat-dialog-title>
    <h2 *ngIf="!isUpdate">{{"sizes.Add Custom Size" | translate}}</h2>
    <h2 *ngIf="isUpdate">{{"sizes.Update Custom Size" | translate}}</h2>

    <button mat-icon-button (click)="openConfirmDialog()" class="close">
      <mat-icon class="pop-close">close</mat-icon>
    </button>
  </div>
  <form [formGroup]="formGroup">
    <mat-dialog-content>
      <div class="mat-dialog-body">
        <div class="fields-group">
          <mat-form-field class="mb-2">
            <mat-label>{{"forms.Title in English" | translate}}</mat-label>
            <input matInput formControlName="title_EN" maxlength="50">
            <mat-error *ngIf="hasError('title_EN', 'required')">{{ 'forms.Required' | translate }}</mat-error>
            <!-- <mat-error *ngIf="hasError('title_EN', 'pattern')">
              {{ 'forms.EntervalidNameinEnglish' | translate }}
            </mat-error> -->
            <mat-error *ngIf="hasError('title_EN', 'duplicated')">
              {{ 'forms.Duplicated' | translate }}</mat-error>
          </mat-form-field>

          <mat-form-field class="mb-2">
            <mat-label>{{"forms.Title in Arabic" | translate}}</mat-label>
            <input matInput formControlName="title_AR" maxlength="50">
            <mat-error *ngIf="hasError('title_AR', 'required')">{{ 'forms.Required' | translate }}</mat-error>
            <!-- <mat-error *ngIf="hasError('title_AR', 'pattern')">
              {{ 'forms.EntervalidNameinArabic' | translate }}
            </mat-error> -->
            <mat-error *ngIf="hasError('title_AR', 'duplicated')">
              {{ 'forms.Duplicated' | translate }}</mat-error>
          </mat-form-field>
        </div>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions>
      <button mat-button type="button" (click)="openConfirmDialog()" class="btn-grey">{{"forms.Cancel" |
        translate}}</button>

      <button *ngIf="!isUpdate" (click)="saveRecord()" mat-raised-button color="primary" [disabled]="loading"
        [class.loading]="loading">
        {{"sizes.Add Size" | translate}}
      </button>

      <button *ngIf="isUpdate" (click)="saveRecord()" mat-raised-button color="primary" [disabled]="loading"
        [class.loading]="loading">
        {{"sizes.Update Size" | translate}}
      </button>
    </mat-dialog-actions>
  </form>
</ng-container>
